
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.94 25.19h8.26v13.56H1.94zM15.87 19.22h8.26v19.53h-8.26zM29.8 13.24h8.26v25.51H29.8zM30.58 1.25l5.41 1.78-1.77 5.41M1.94 19.22L35.78 3.19"}})])
          )
        }
      }
    